$(()=> {

  const apiDeleteProfile = '/plan/perfil/delete';
  const apiDeletePet = '/users/pet/delete';

  let btnDeletePet  = $('.button--delete.delete-pet');
  let btnDeleteProfile = $('.button--delete.delete-profile');

  let deleteProfile = async (e)=> {
    e.preventDefault();

    let msj = '¿Seguro que desea eliminar este perfil?';
    let el = $(e.currentTarget);
    let code = el.data('code');

    if (confirm(msj)) {
      try {

        let response = await fetch(`${apiDeleteProfile}/${code}`, {
          method: 'DELETE',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        })

        let data = await response.json();

        if (data.success) {
          location.reload();
        }

      } catch (error) {
        console.error('error: ', error);
      }
    }
  }

  let deletePet = async (e)=> {
    e.preventDefault();

    let msj = '¿Seguro que desea eliminar este perfil?';
    let el = $(e.currentTarget);
    let code = el.data('code');

    if (confirm(msj)) {
      try {

        let response = await fetch(`${apiDeletePet}/${code}`, {
          method: 'DELETE',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        })

        let data = await response.json();

        if (data.success) {
          location.reload();
        }

      } catch (error) {
        console.error('error: ', error);
      }
    }
  }

  btnDeletePet.on('click', deletePet);
  btnDeleteProfile.on('click', deleteProfile);
});
